// Get references to the form, inputs, and button
const nameInput = document.getElementById("nameText")
const nameError = document.querySelector(".name-input-error")
const surnameInput = document.getElementById("surnameText")
const surnameError = document.querySelector(".surname-input-error")
const textarea = document.getElementById("dedicationText")
const dedicationError = document.querySelector(".dedication-input-error")
const atcButton = document.querySelector(".atc-button") // Select the button by name attribute

// Get references to the hidden date inputs (if they exist)
const hiddenDayInput = document.getElementById("hidden-day")
const hiddenMonthInput = document.getElementById("hidden-month")
const hiddenYearInput = document.getElementById("hidden-year")
const productSelector = document.querySelector("product-selector")

// Function to show or hide error messages

function validateInput(input, errorElement) {
    if (input.required && input.value.trim() === "") {
        errorElement.style.display = "block"
        return false
    } else {
        errorElement.style.display = "none"
        return true
    }
}

// Function to enable or disable the button based on input content
function toggleButtonState() {
    let isAvailable = productSelector.getVariantData()[0].available;

    if (productSelector.currentVariant) {
        isAvailable = productSelector.currentVariant.available
    }

    if (!isAvailable) {
        atcButton.disabled = true
        return
    }

    if (
        (nameInput && nameInput.required && nameInput.value.trim() === "") ||
        (surnameInput &&
            surnameInput.required &&
            surnameInput.value.trim() === "") ||
        (textarea &&
            textarea.hasAttribute("required") &&
            textarea.value.trim() === "")
    ) {
        atcButton.disabled = true
        return
    }

    if (hiddenDayInput && hiddenMonthInput && hiddenYearInput) {
        if (
            hiddenDayInput.value.trim() === "" ||
            hiddenMonthInput.value.trim() === "" ||
            hiddenYearInput.value.trim() === ""
        ) {
            atcButton.disabled = true
            return
        }
    }

    atcButton.disabled = false
}

// Character count and input validation for name input
if (nameInput) {
    const charCountName = document.getElementById("charCountName")
    const maxLengthName = nameInput.getAttribute("maxlength")

    if (charCountName) {
        charCountName.textContent = `${nameInput.value.length}/${maxLengthName}`
    }

    nameInput.addEventListener("input", function () {
        if (charCountName) {
            charCountName.textContent = `${nameInput.value.length}/${maxLengthName}`
        }
        if (nameError) validateInput(nameInput, nameError)
        toggleButtonState()
    })
}

// Character count and input validation for surname input
if (surnameInput) {
    const charCountSurname = document.getElementById("charCountSurname")
    const maxLengthSurname = surnameInput.getAttribute("maxlength")

    if (charCountSurname) {
        charCountSurname.textContent = `${surnameInput.value.length}/${maxLengthSurname}`
    }

    surnameInput.addEventListener("input", function () {
        if (charCountSurname) {
            charCountSurname.textContent = `${surnameInput.value.length}/${maxLengthSurname}`
        }
        if (surnameError) validateInput(surnameInput, surnameError)
        toggleButtonState()
    })
}

function enforceLineLimit(textarea, maxLines) {
    if (!textarea) return 0 

    const lines = textarea.value.split("\n")
    if (lines.length > maxLines) {
        textarea.value = lines.slice(0, maxLines).join("\n")
    }
    return textarea.value.split("\n").length // Return updated current line count
}

if (textarea) {
    const charCountDedication = document.getElementById("charCountDedication")
    const lineCountDedication = document.getElementById("lineCountDedication")
    const maxLengthDedication = textarea.getAttribute("maxlength")
    const maxLineLengthDedication =
        parseInt(textarea.getAttribute("maxLineLength")) || 0

    if (charCountDedication) {
        charCountDedication.textContent = `${textarea.value.length}/${maxLengthDedication}`
    }
    if (lineCountDedication) {
        lineCountDedication.textContent = `Lines: ${textarea.value.split("\n").length}/${maxLineLengthDedication}`
    }

    textarea.addEventListener("input", function () {
        const currentLines = enforceLineLimit(textarea, maxLineLengthDedication)

        if (charCountDedication) {
            charCountDedication.textContent = `${textarea.value.length}/${maxLengthDedication}`
        }
        if (lineCountDedication) {
            lineCountDedication.textContent = `Lines: ${currentLines}/${maxLineLengthDedication}`
        }

        if (dedicationError) validateInput(textarea, dedicationError)
        toggleButtonState()
    })
}

// Initialize button state on page load
toggleButtonState()
window.toggleButtonState = toggleButtonState

window.addEventListener("pageshow", function () {
    toggleButtonState()
})
